import { render, staticRenderFns } from "./ClassificationDegrees.vue?vue&type=template&id=5bafcc9e&"
import script from "./ClassificationDegrees.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports